import React from 'react'
import styled from 'styled-components'
import {devices} from '../../components/MediaQuerys/BreakpointsAndDevices'


import desarrolloCinndetImg from '../../assets/images/desarrolloCinndet.svg'
import phoneIcon from '../../assets/images/phone.svg'
import mailIcon from '../../assets/images/mail.svg'
import {FooterContainer} from '../container/Container'
// Styled Components Section
const Icon = styled.img`
    width: ${props => props.width};
    height: ${props => props.height};
    bottom: 0;
    align-items: end;
    display: none;
    @media only screen and ${devices.mobileS} {
        
        
    }
    @media only screen and ${devices.mobileM} {
        
        
    }
    @media only screen and ${devices.tablet} {
        display: block;
    }
    @media only screen and ${devices.laptop}{
        display: block;

    }
    @media only screen and ${devices.laptopL}{
        display: block;

    }
`
const InfoSection = styled.div`
    width: 100%;
    display: grid;
    row-gap: 10px;
    padding: 15px;
    /* background-color: black ; */
    
    `
const SmallSection = styled.div`
    display: grid;
    grid-auto-flow: column;
    justify-content: end;
    align-items: center;
    column-gap: 20px;
    width: 100%;
`
const Text = styled.p`
    font-family: 'Montserrat-Regular';
    color: ${props =>props.color};
    font-weight: 800;
    margin: 0;
    width: 80%;

`
// Styled Components Section
export const Footer = () => {
    return (
        <FooterContainer>
            <Icon
                src={desarrolloCinndetImg}
                width='260px'
                height='70px'/>
            <InfoSection>
                <Text color='#10609A'>Para más información:</Text>
                <SmallSection>
                <Icon
                    src={phoneIcon}
                    width='26px'
                    height='26px'/>
                <Text color='#10609A'>300 265 2699</Text>
                    <Icon
                        src={mailIcon}
                        width='26px'
                        height='26px'/>
                    <Text color='#10609A'>cursosformacionartisticabosa@gmail.com</Text>
                </SmallSection>
            </InfoSection>
        </FooterContainer>
    )
}
